import AuthProvider from "./context/security/AuthProvider";
import Router from "./route/Router";
import "./app.css";
import ResetPassword from "./components/security/ResetPassword";
import EmailPassword from "./components/security/EmailPassword";
import { Route, Routes } from "react-router-dom";
function App() {
  return (
    <AuthProvider>
      {/* <Routes>
        <Route path="/resetPassword/:token" component={ResetPassword} />
        <Route path="/mailResetPassword" component={EmailPassword} />
      </Routes> */}
      <Router />
    </AuthProvider>
  );
}

export default App;
